module.exports = __webpack_public_path__ + "img/SG002.54401467.png";